import { observer } from 'mobx-react-lite';
import React from 'react';
import { Route, useLocation } from 'react-router-dom';
import { useStore } from '@uplift/hooks';

type Props = {
  redirectUrl?: string;
  exact?: boolean;
  path: string | string[];
};

export const PrivateRoute: React.FC<Props> = observer(
  ({ children, redirectUrl, ...props }) => {
    const { authStore } = useStore();
    const { search } = useLocation();

    React.useEffect(() => {
      if (!authStore.isLoggedIn && redirectUrl) {
        const params = new URLSearchParams(search);

        authStore.logout(redirectUrl, {
          redirectAfterLogin: true,
          searchParams: params
        });
      }
    }, [ authStore.isLoggedIn, redirectUrl, authStore, search ]);

    if (authStore.loading) {
      return null;
    }

    if (!authStore.isLoggedIn) {
      return null;
    }

    return <Route {...props}>{children}</Route>;
  }
);
